const eventInfo = {
	february2024: [
		{
			image: 'shopify',
			title: '1',
			intro: 'Discover key insights on Shopify benefits, scalability, migration and more',
			url: '#shopify-meetup-cta',
		},
		{
			image: 'shopify',
			title: '2',
			intro: 'Connect with industry leaders in dedicated networking sessions, coffee breaks, and a lunch meet-up',
			url: '#shopify-meetup-cta',
		},
		{
			image: 'shopify',
			title: '3',
			intro: 'Engage with content specifically focused on optimising Shopify stores',
			url: '#shopify-meetup-cta',
		},
	],
};

export default eventInfo;
